<script setup>

const colorMode = useColorMode()

const props = defineProps({
  options: {
    type: Array,
  },
	selectedOption: {
		type: String
	}
})

const open = ref(false)
const selected = ref(props.selectedOption)
const availableOptions = computed(() => {
	return props.options.filter(item => item !== selected.value)
})

const emit = defineEmits(['update'])

const select = (option) => {
	selected.value = option
	open.value = false

	emit('update', selected.value)
}

</script>

<template>
	<div v-click-outside="() => open = false" class="relative z-10 dark:text-light text-dark text-sm xl:text-lg xl:min-w-[465px]">
		<div @click="open = !open" class="border dark:border-light border-dark py-[14px] px-6 cursor-pointer flex justify-between items-center">
			<span class="min-w-0 text-ellipsis overflow-hidden whitespace-nowrap">{{ $t(`order.${selected}`) }}</span>
			<svg :class="{'rotate-180' : open}" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
				<path d="M10 14L16 20L22 14" :stroke="colorMode.preference === 'dark' ? '#F5F5F5' : '#1D1D1B'" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
			</svg>
		</div>
		<div v-if="open" class="absolute top-[100%] left-0 w-full border dark:border-light dark:bg-dark border-dark bg-light border-t-0">
			<div
				v-for="option in availableOptions"
				:key="option"
				@click="select(option)"
				class="py-[14px] px-6 cursor-pointer dark:hover:bg-light dark:hover:text-dark hover:bg-dark hover:text-light transition-all duration-100"
			>
				{{ $t(`order.${option}`) }}
			</div>
		</div>
	</div>
</template>